import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/index";
import CallToAction from "../partials/cta";
import FieldLabel from "../../../components/label";
import { withStyles } from "@mui/styles";
import { Box, Grid } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { convertDateToString } from "../../../helpers/utils";
import { journeyStage } from "../../../mapping";

function ApplicationList({
  classes: { borderContainter, cardContainer, formGroup },
  errorMessage,
  form,
  onClickHandler,
  isFormSubmitted,
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  return state?.proposalList.map((item, index) => {
    return (
      <Box
        key={`application${item.oid}`}
        className={borderContainter}
        m={0}
        p={1}
      >
        <Box className={formGroup} textAlign={"left"}>
          <Grid container spacing={2} textAlign={"center"}>
            {/* <Grid item xs={5}>
              <FieldLabel label={"Product Name:"} color="gray" />
            </Grid> */}
            <Grid item xs={12}>
              <FieldLabel label={item.product_name} variant="body2" />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Proposal:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel label={item.proposalno} />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Category:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel label={item.category_name} />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Customer Name:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel label={item.name ?? "-"} />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Date of Birth:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel label={convertDateToString(item.dob, "DD-MM-YYYY")} />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Premium:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel
                label={Number(item.premium).toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                  style: "currency",
                  currency: "INR",
                })}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={5}>
              <FieldLabel label={"Status:"} color="gray" />
            </Grid>
            <Grid item xs={7}>
              <FieldLabel label={journeyStage[item.status]} />
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={2} mt={0} mb={1}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CallToAction
              buttonType={"button"}
              color="secondary"
              errorMessage={errorMessage}
              form={form}
              handleClick={() => onClickHandler(item)}
              isFormSubmitted={isFormSubmitted}
              text={"Complete Application"}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </Box>
    );
  });
}

export default withStyles(useStyles, { withTheme: true })(ApplicationList);
